module.exports = "<div> <p v-for=\"item in items\"> <input type=radio v-model=selected :class=\"[withGap ? 'with-gap' : '']\" :name=group :id=\"'_' + group + item.value\" :value=item.value :disabled=item.disabled /> <label :for=\"'_' + group + item.value\">{{item.label}}</label> </p> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../~/material-ui-vue/components/forms/radio.vue
 ** module id = 284
 ** module chunks = 0
 **/